<payment-language-dropdown
  [currentLanguage]="currentLanguage$ | async"
  (languageSelected)="onLanguageSelected($event)"
>
</payment-language-dropdown>
